document.querySelectorAll('.form-group__reset').forEach((resetButton) => {
  const input = resetButton
    .closest('.form-group__reset-wrap')
    ?.querySelector('input');
  if (input && input.value) {
    resetButton.classList.add('form-group__reset--show');
  }

  const resetValue = (e) => {
    const targetInput = e.currentTarget
      ?.closest('.form-group__reset-wrap')
      ?.querySelector('input');
    if (targetInput) {
      targetInput.value = '';
      targetInput.removeAttribute('value');
      resetButton.classList.remove('form-group__reset--show');
      targetInput.focus();
    }
  };

  input?.addEventListener('input', () => {
    if (input.value) {
      resetButton.classList.add('form-group__reset--show');
    } else {
      resetButton.classList.remove('form-group__reset--show');
    }
  });

  input?.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      resetValue(e);
    }
  });

  resetButton.addEventListener('click', (e) => {
    resetValue(e);
  });
});
